<template>

  <div class="flex max-w-xl mb-4 mx-8 sm:mx-auto overflow-hidden bg-white shadow-lg">
    <div class="w-1/3 bg-cover" :style="{backgroundImage: 'url('+ image +')'}"></div>

    <div class="w-2/3 ">
      <div class="max-w-2xl px-8 py-4 mx-auto bg-white">
        <div class="flex items-center justify-between">
          <span class="text-sm font-light text-gray-600 ">{{moment(createdAt)}}</span>
          <a @click="()=>!loading && deleteRecipe({deleteRecipeId:id})" class="px-3 py-1 text-sm font-bold text-gray-100 transition-colors duration-200 transform bg-red-600 rounded cursor-pointer hover:bg-red-500">
            {{loading ? "Deleting..." : "Delete"}}
          </a>
        </div>

        <div class="mt-2">
          <router-link :to="{name:'recipe',params:{id}}" class="text-2xl font-bold text-gray-700 hover:text-gray-600 hover:underline">{{ title }}</router-link>
          <p class="mt-2 text-gray-600 line-clamp-4">{{instruction}}</p>
        </div>

        <div class="flex items-center justify-between mt-4">
          <router-link :to="{name:'recipe',params:{id}}" class="text-green-600 hover:underline">Read more</router-link>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {useMutation} from "@vue/apollo-composable";
import { ref } from 'vue'
import gql from "graphql-tag";
import moment from "moment"

const RECIPES_DELETE = gql`mutation DeleteRecipeIngredient($deleteRecipeId: ID!) {
  deleteRecipeIngredient(id: $deleteRecipeId) {
    name
  }
}
`

export default {
  name: "RecipesCard",
  data(){
    return {
      example: "",
    }
  },
  filters: {

  },
  props: {
    title: String,
    instruction: String,
    image: String,
    createdAt: String,
    id: String,
  },
  methods: {
    moment: function (date) {
      // return moment(parseInt(date)).format('MMMM Do YYYY');
      return moment(parseInt(date)).startOf('hour').fromNow()
    }
  },
  setup(){

    let isDelete = ref(false)

    const { mutate:deleteRecipe, loading, error, onDone } = useMutation(RECIPES_DELETE)

    onDone(() => {
          isDelete = true
          console.log(isDelete)
        }
    )

    return {
      deleteRecipe,
      loading,
      error,
      isDelete
    }
  },

}
</script>

<style scoped>

</style>